//Lib 
import { mapState } from "vuex";

// Api
import api from '@/api/baseApi';

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE } from "@/constant/extraService";
import { SERVICE_TYPE, MACHINE_LIST_FILTER_BY } from "@/constant/rental";

// Function 
const queryString = require('query-string');

export default {

  extends: baseExtraService,

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },

  data() {

    return {
      descriptionProcessingTime: "After you submit your request successfully. We will process your request within 1 hours.",

      machineListRequest: {
        serviceType: SERVICE_TYPE.ALL,
        filterBy: MACHINE_LIST_FILTER_BY.ALL,
        orderBy: 'A.CREATED_AT',
        directionSort: 'DESC',
      },
      machineList: null,
      machineId: null,
      note: null,
    };
  },

  mounted() {
    this.machineListView();
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    //#region Close this pop-up
    closeThisPopup() {
      this.closePopup(POPUP_ID.EXTRA_SERVICE_PARSEC);
    },
    //#endregion

    //#region Machine list view
    machineListView() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
        .then((res) => {
          this.machineList = res.data;
          if (this.machineList && this.machineList.length > 0) {
            this.isShowErrorInformation = false;
          } else {
            this.isShowErrorInformation = true;
          }
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch(error => {
          this.processCatchApiRequest(error, "Request failed ...")
        });
    },
    //#endregion

    //#region Expand image threshold send request
    send() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          type: EXTRA_SERVICE_TYPE.PARSEC,
          machineId: this.machineId,
          note: this.note,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        this.createRequest(
          data,
          () => { this.closeThisPopup() }
        )
      }, this.smoothTimeOut);
    },
    //#endregion
  },
}